import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Shortcuts } from './Shortcuts';

export const ShortcutSettings = () => {
  const profile = useSelector((state) => state?.login?.profile);
  const [contentTab, setContentTab] = useState('Shortcuts');

  const handleContentChange = (event, newValue) => {
    setContentTab(newValue);
  };
  const pagesSwitch = (content) => {
    if (content === 'Shortcuts') {
      return <Shortcuts />;
    }
    return null;
  };

  return (
    <>
      <Box sx={{ padding: 3, fontWeight: 'bold', fontSize: 24 }}>
        Bonjour {profile.firstName},
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={contentTab}
          onChange={handleContentChange}
          sx={{
            width: 180,
            position: 'sticky', // Reste fixé en haut
            top: 64, // Positionnement en haut
            height: '100vh', // Remplit la hauteur de l'écran
            overflowY: 'auto', // Ajoute un scroll interne si nécessaire
            zIndex: 1000, // Reste au-dessus du contenu
            flexShrink: 0,
          }}
        >
          <Tab value={'Shortcuts'} label={'Modifier les raccourcis'} />
          <Tab value={'Others'} label={'Autres'} disabled />
        </Tabs>
        {pagesSwitch(contentTab)}
      </Box>
    </>
  );
};
